import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { RetornoSelecao } from '../../../shared/gridview/RetornoSelecao';
import { ConsultaEstoqueFiltroService } from './veiculo-estoque-filtro/veiculo-estoque-filtro.service';
import { FiltroDealers } from './veiculo-estoque-filtro/filtro-dealer';
import { DealerItem } from '../../../shared/filtro-dealers/filtro-dealers.component';

declare var $: any;

@Component({
  selector: 'app-veiculo-estoque',
  templateUrl: './veiculo-estoque.component.html',
  styleUrls: ['./veiculo-estoque.component.scss']
})
export class ConsultaEstoqueComponent implements OnInit {
  filtros: any = {}; 
  selecionado: object;
  selecionados = [];
  filtroDealers: FiltroDealers;
  modalTexto: string = 'Selecione os Dealers';
  displayFiltrosDealers: boolean = false;
  tipoData = [
    { value: '2', name: 'Data Última Atualização' },
    { value: '1', name: 'Data Emissão' },
    { value: '3', name: 'Desconsiderar Data' }
  ];
  datas: any = {
    data_inicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    data_final: new Date(),
    tipo_data: '3'
  };

  constructor(private servico: ConsultaEstoqueFiltroService, private translate: TranslateService) {
    this.filtroDealers = new FiltroDealers(this.servico);
    this.carregarFiltroVazio();
   }

  ngOnInit() {
    this.filtroDealers.carregar();
    this.getTranslate();
  }

  carregarFiltroVazio() {
    this.filtros.grupo_economico = null;
    this.filtros.dealers = null
    this.filtros.chassi = null;
    this.filtros.situacao = null;
    this.filtros.marca = null;
    this.filtros.placa = null;
    this.filtros.status = null;
    this.filtros.exibirTransf = null;
  }

  public getListagemComFiltros(): boolean {
    return this.filtros.grupo_economico
    || this.filtros.dealers
      || this.filtros.chassi
      || this.filtros.situacao
      || this.filtros.marca
      || this.filtros.placa
      || this.filtros.status
      || this.filtros.exibirTransf
      || this.filtros.dataInicio
      || this.filtros.dataFim
      || this.filtros.tipoData;
  }

  selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  removerDealer(dealer: any) {
    dealer.selecionado = false;
  }

  onAdicionarDealerFiltro(dealer: DealerItem) {
    dealer.selecionado = true;
  }

  filtrar() {
    return this.selecionados;
  }

  pesquisar() {
    this.selecionados = [];
    const sel = [];
    this.incluirFiltroDealers(sel);
    this.carregarFiltrosEspecificos(sel);
    
    this.selecionados = sel;
  }

  carregarFiltrosEspecificos(sel: any[]) {
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        const item = {'chave': chave, 'valor': this.filtros[chave]};
        sel.push(item);
      }
    }
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtroDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtroDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private getTranslate() {
    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {

        if (event.lang === 'br') {
          this.modalTexto = 'Selecione os Dealers';
        }

        if (event.lang === 'gb') {
          this.modalTexto = 'Select Dealers';
        }
    });
  }

  selecionar(selecionado: RetornoSelecao) {
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#veiculo-estoque-filtro').modal();
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.datas.data_final = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.datas.data_inicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

}
